export const borderRadius = {
  'border-radius-1': '2px',
  'border-radius-2': '4px',
  'border-radius-3': '8px',
  'border-radius-4': '16px',
  'border-radius-5': '100px',
};
